// @flow
import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import Layout from '../layout'
import Icon from '../components/icon'
import styles from './venue.module.css'

const accommodationLinks = [
  {
    name: 'Boutique Hostel Forum',
    href: 'https://hostelforumzadar.com/en',
  },
  {
    name: 'Guesthouses I and II',
    href: 'http://gostinjacbsm.com/guesthouses-zadar',
  },
  {
    name: 'Youth Hostel, University of Zadar',
    href: 'http://www.unizd.hr/studentskidom/english',
  },
  {
    name: 'Youth Hostel Zadar',
    href:
      'https://www.tripadvisor.com/Hotel_Review-g295374-d602003-Reviews-Youth_Hostel_Zadar-Zadar_Zadar_County_Dalmatia.html',
  },
  {
    name: 'Airbnb',
    href: 'https://www.airbnb.com',
  },
  {
    name: 'Booking.com',
    href: 'https://www.booking.com',
  },
]

function VenuePage() {
  const data = useStaticQuery(graphql`
    query VenuePage {
      site {
        siteMetadata {
          email
        }
      }
    }
  `)
  const { email } = data.site.siteMetadata
  return (
    <Layout>
      <Helmet>
        <title>Venue</title>
      </Helmet>
      <h1>Venue</h1>
      <div className={styles.mapContainer}>
        <div className={styles.map}>
          <iframe
            title="Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2864.6430931106966!2d15.224682527949344!3d44.11135590888703!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4761fa69327d91fd%3A0x57c6cb35fb16dacf!2sUl.+Mihovila+Pavlinovi%C4%87a+1%2C+23000%2C+Zadar!5e0!3m2!1sen!2shr!4v1559235731562!5m2!1sen!2shr"
            width="600"
            height="300"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen
          />
        </div>
        <div className={styles.info}>
          <a
            className={styles.virtualTour}
            href="http://www.unizd.hr/Portals/15/slike/sveuciliste.html?s=pano155&h=177&v=-2&f=90&s=pano143&h=4&v=13&f=90"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon className={styles.icon} id="eye" size={28} />
            <span className={styles.text}>Virtual tour</span>
          </a>
          <address className={styles.address}>
            <b>Old Campus, University of Zadar</b>,
            <br />
            Mihovila Pavlinovića 1,
            <br />
            23000 Zadar
            <br />
            <a href={`mailto:${email}`}>{email}</a>
          </address>
        </div>
      </div>
      <h2>How to get to Zadar?</h2>
      <p>
        {"If you're looking for traveling information on how to get to Zadar, "}
        take a look at{' '}
        <a href="https://www.zadar.travel/en">Zadar Tourist Board</a>.
      </p>
      <h2>Accommodation</h2>
      <p>You can find accommodation here:</p>
      <ol>
        {accommodationLinks.map((link) => (
          <li key={link.name}>
            <a href={link.href}>{link.name}</a>
          </li>
        ))}
      </ol>
    </Layout>
  )
}

export default VenuePage
